<template>
    <div class="bg-box">
        <div class="box-card" v-loading="loading">
            <div class="content">
                <div class="filter-container">
                    <!-- <el-input
            v-model="listQuery.userNo"
            clearable
            class="filter-item"
            style="width: 150px;"
            placeholder="请输入账号"
          /> -->

                    <el-input v-model="listQuery.serialNo" clearable class="filter-item" style="width: 150px"
                        placeholder="请输入流水号" />

                    <el-select v-model="listQuery.payType" clearable style="width: 150px" class="filter-item"
                        placeholder="请选择付款方式">
                        <el-option v-for="(item, index) in payTypeList" :key="index" :label="item.label"
                            :value="item.value" :disabled="item.disabled" />
                    </el-select>

                    <el-select v-model="listQuery.status" clearable style="width: 150px" class="filter-item"
                        placeholder="请选择订单状态">
                        <el-option v-for="(item, index) in statusList" :key="index" :label="item" :value="index" />
                    </el-select>

                    <el-date-picker v-model="datePick" class="filter-item" type="datetimerange" range-separator="至"
                        start-placeholder="订单开始" end-placeholder="订单结束" />

                    <!-- <el-date-picker
            v-model="datePayPick"
            class="filter-item"
            type="datetimerange"
            range-separator="至"
            start-placeholder="支付开始"
            end-placeholder="支付结束"
          /> -->

                    <el-button class="filter-item confirm" type="primary" icon="el-icon-search" style="margin-left: 0px"
                        @click="handleFilter">查找
                    </el-button>
                </div>

                <el-table stripe :data="tableData" class="file_table classify_table" style="width: 100%"
                    :height="fixedHeight">
                    <!-- <el-table-column
            prop="userNo"
            label="账号"
          >
          </el-table-column> -->
                    <el-table-column prop="nickName" label="支付方式" width="110" header-align="center" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.payType==0">
                                在线支付
                            </span>
                            <span v-if="scope.row.payType==2">
                                对公转账
                            </span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="oprUserNo" label="操作人" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="amount" label="金额" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="serialNo" label="流水号" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="createTime" label="订单创建时间" width="180" header-align="center" align="center">
                    </el-table-column>

                    <el-table-column prop="payTime" label="支付时间" width="180" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="status" label="状态" width="90" header-align="center" align="center">
                        <template slot-scope="scope">
                            <span>
                                <el-tag type="danger" v-if="scope.row.status == '2'">已关闭</el-tag>
                                <el-tag type="info" v-if="scope.row.status == '0'">未支付</el-tag>
                                <el-tag type="success" v-if="scope.row.status == '1'">已支付</el-tag>
                            </span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="操作" width="180" header-align="center">
                        <template slot-scope="scope">
                            <a @click="onPay(scope.row)" v-if="scope.row.status == 0">
                                支付
                            </a>

                            <a v-if="scope.row.payType == 2&&scope.row.status != '2'" @click="onUpload(scope.row)">
                                凭证
                            </a>

                            <a v-if="scope.row.status == 0" @click="onClickClose(scope.row)">
                                关闭
                            </a>
                        </template>
                    </el-table-column>
                </el-table>

                <pagination class="tab-pagination" v-show="total > 0" :total="total" :pageNo.sync="listQuery.pageNo"
                    :pageSize.sync="listQuery.pageSize" @pagination="getList" />
            </div>
        </div>
        <pay-info ref="payInfo" @ok="handleFilter"></pay-info>

        <el-dialog :visible.sync="dialog" :close-on-click-modal="false" title="支付凭证" append-to-body modal-append-to-body
            width="800px" :z-index="1000" @close="cancel">

            <div class="upload-opt-box" v-loading="uploadLoading">

                <!--        <el-upload-->
                <!--          :action="uploadURL"-->
                <!--          :http-request="httpRequest"-->
                <!--          :show-file-list="false"-->
                <!--          drag-->
                <!--          :disabled="uploadItem.status != 0"-->
                <!--          :class="uploadClass"-->
                <!--          accept=".jpg,.jpeg,.png,.gif"-->
                <!--        >-->
                <!--          <i class="el-icon-upload"></i>-->
                <!--          <div class="el-upload_png_text">{{ uploadItem.status != 0?'订单已结束，无法上传':'将凭证拖到此处，或点击上传' }}</div>-->
                <!--        </el-upload>-->

                <!--        <el-image-->

                <!--          v-if="uploadItem.payReceiptFile"-->
                <!--          :src="uploadItem.payReceiptFile"-->
                <!--         class="img"-->
                <!--         fit="contain"-->
                <!--          :preview-src-list="srcList"-->
                <!--        >-->
                <!--        </el-image>-->
                <el-form :model="formData" ref="vForm" label-position="left" label-width="100px" size="default"
                    @submit.native.prevent>
                    <el-row>
                        <el-col :span="24" class="grid-cell">
                            <el-upload :action="uploadURL" :http-request="httpRequest" :show-file-list="false" drag
                                :disabled="uploadItem.status != 0" :class="uploadClass" accept=".jpg,.jpeg,.png,.gif">
                                <i class="el-icon-upload"></i>
                                <div class="el-upload_png_text">{{ uploadItem.status != 0?'订单已结束，无法上传':'将凭证拖到此处，或点击上传'
                                    }}</div>
                            </el-upload>
                        </el-col>
                        <el-col :span="24" class="grid-cell">
                            <!--            <div style="overflow-y:scroll;height: 320px;box-shadow: 0px 0px 10px 1px #7b7a7a;" >-->
                            <div class="block">
                                <el-image :src="uploadItem.payReceiptFile" :preview-src-list="srcList" class="img"
                                    fit="contain">
                                    <div slot="error" class="image-slot">
                                        <!--                    <h1 style="color:red;">老铁加载失败了...</h1>-->
                                    </div>
                                </el-image>
                            </div>
                            <!--            </div>-->
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button type="text" class="cancel" @click="cancel">关 闭</el-button>
            </div>
        </el-dialog>


        <el-dialog :visible.sync="payDialog" :close-on-click-modal="false" title="在线支付" append-to-body
            modal-append-to-body width="60%" @close="onClosePay">
            <iframe draggable="true" :src="payUrl" :style="{height:fixediframeHeight,width:'100%'}">
            </iframe>
            <div slot="footer" class="dialog-footer">
                <el-button type="text" class="cancel" @click="onClosePay">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { screenSizeMixin } from "@/util/screenSizeMixin";
    import { mapGetters } from "vuex";
    import Pagination from "@/components/Pagination/index.vue";
    import payInfo from "./payInfo.vue";
    export default {
        name: "rechargeOrder",
        components: { Pagination, payInfo },
        mixins: [screenSizeMixin],
        data() {
            return {
                uploadURL: this.$uploadFile.url,
                datePick: [],
                datePayPick: [],
                uploadLoading: false,
                dialog: false,
                total: 0,
                listQuery: {
                    pageNo: 1,
                    pageSize: 20,
                    orgCode: undefined,
                    oprUser: undefined,
                    status: undefined,
                    payType: undefined,
                    serialNo: undefined,
                    beginTime: undefined,
                    endTime: undefined,
                },
                loading: true,
                orgCode: this.$localStorage.getItem("orgCode"),
                tableData: [],
                username: localStorage.getItem("BAILIAN-SHIBIE-USERNAME"),
                payTypeList: [{
                    value: 0,
                    label: '在线支付'
                }, {
                    value: 2,
                    label: '对公转账'
                }],
                statusList: ["未支付", "已支付", "已关闭"],
                uploadItem: {},
                srcList: [],
                timerId: undefined,
                stopTimerId: undefined,
                payDialog: false,
                payUrl: undefined
            };
        },
        // mounted() {
        //   this.getList();
        // },
        activated() {
            const serialNo = this.$route.params.serialNo
            if (serialNo) {
                this.onSetPay(this.$route.params.payUrl)
                this.pollingLoad(serialNo)
            }
            this.getList();
        },
        computed: {
            ...mapGetters(["userType"]),
            fixedHeight() {
                return this.screenHeight * 0.8 - 180;
            },
            fixediframeHeight() {
                return this.screenHeight * 0.8 - 80 + 'px';
            },
            uploadClass() {
                const className = 'upload-demo avatar-uploader'
                return this.uploadItem.status != 0 ? className + ' upload-disabled' : className
            }
        },
        methods: {
            pollingLoad(serialNo) {
                const that = this;
                this.payDialog = true
                //   this.$confirm("确认已经支付成功?", "提示", {
                //     confirmButtonText: "确定",
                //     cancelButtonText: "取消",
                //     type: "warning",
                //   }).then(() => {
                // const param = {
                //       orgCode:that.orgCode,
                //       oprUser:that.username,
                //       serialNo
                //     }
                // this.$axios({
                //   url: that.$resource.tRechargeOrderPage
                //     .replace("{pageNo}", 1)
                //     .replace("{pageSize}", 10),
                //   method: "post",
                //   data: param,
                // })
                //   .then((res) => {
                //     const bl = that.$utils.ajaxResponse.call(that, res);
                //     if (bl) {
                //       const list = res.data.data.list;
                //       if(list[0].status != '0'){
                //         this.$message({
                //           message: "支付成功",
                //           type: "success",
                //         });
                //         that.getList()
                //       }else{
                //         this.$message.error("未支付成功，请继续支付");
                //       }
                //     }
                //   })
                // });

                // if(this.timerId){
                //   this.stopPolling()
                // }
                // const that = this
                // this.timerId = setInterval(() => {
                //   const param = {
                //   orgCode:that.orgCode,
                //   oprUser:that.username,
                //   serialNo
                // }
                // this.$axios({
                //   url: that.$resource.tRechargeOrderPage
                //     .replace("{pageNo}", 1)
                //     .replace("{pageSize}", 10),
                //   method: "post",
                //   data: param,
                // })
                //   .then((res) => {
                //     const bl = that.$utils.ajaxResponse.call(that, res);
                //     if (bl) {
                //       const list = res.data.data.list;
                //       if(list[0].status != '0'){
                //         that.getList()
                //         clearInterval(that.timerId)
                //       }
                //     }
                //   })
                // }, 3000);
                // this.stopTimerId = setTimeout(that.stopPolling, 5 * 60 * 1000);
            },
            // stopPolling() {
            //   clearInterval(this.timerId);
            //   clearTimeout(this.stopTimerId);
            // },
            onClosePay() {
                this.payDialog = false
                this.getList()
            },
            onClosePay888() {
                //console.log('8888')
                this.payDialog = false
            },
            onUpload(row) {
                this.uploadItem = row;
                this.uploadLoading = false;
                //console.log(this.uploadItem.payReceiptFile, 'rrrr:', this.uploadItem, this.uploadItem.payReceiptFile)
                //console.log('serialNo:', this.uploadItem.serialNo)
                this.showImg(row.payReceiptFile)
                this.dialog = true;
            },
            showImg(payReceiptFile) {
                this.srcList = [];
                this.srcList.push(payReceiptFile);
            },
            cancel() {
                this.dialog = false;
            },
            httpRequest(data) {
                const formData = new FormData();
                formData.append("file", data.file);
                this.$message("正在上传,请稍等");
                const that = this;
                this.uploadLoading = true;
                this.$axios({
                    url: this.$resource.ocrEnterpriceCode.replace(
                        "{serialNo}",
                        this.uploadItem.serialNo
                    ),
                    method: "post",
                    data: formData,
                }).then((res) => {
                    this.uploadLoading = false;
                    const bl = this.$utils.ajaxResponse.call(this, res);
                    if (bl) {
                        //console.log(res.data.data, 'payReceiptFile', res.data.data.payReceiptFile)
                        this.showImg(res.data.data.payReceiptFile)
                        this.uploadItem.payReceiptFile = res.data.data.payReceiptFile
                        // this.showImg(res.data.data.thumbnailPath)
                        // this.uploadItem.payReceiptFile = res.data.data.thumbnailPath
                        this.$message({
                            message: "上传成功",
                            type: "success",
                        });
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
            },
            handleFilter() {
                if (this.datePick && this.datePick.length != 0) {
                    this.listQuery.beginTime = this.$moment(this.datePick[0]).format(
                        "YYYY-MM-DD HH:mm:ss"
                    );
                    this.listQuery.endTime = this.$moment(this.datePick[1]).format(
                        "YYYY-MM-DD HH:mm:ss"
                    );
                } else {
                    this.listQuery.beginTime = undefined;
                    this.listQuery.endTime = undefined;
                }
                this.listQuery.page = 1;
                this.getList();
            },
            onSetPay(url) {
                if (url.indexOf("https") < 0) {
                    url = url.replace('http', 'https')
                }
                //console.log(url)
                this.payUrl = url
            },
            onPay(row) {
                const that = this
                this.$axios({
                    url: this.$resource.payOrdersCheck,
                    method: "post",
                    data: {
                        serialNo: row.serialNo,
                        oprUser: this.username,
                        orgCode: this.orgCode,
                        payType: row.payType
                    },
                }).then((res) => {
                    if (res.data.data == 1) {
                        that.getList()

                    } else {
                        if (row.payType == 0) {
                            this.onSetPay(row.payUrl)
                            // window.open(row.payUrl,"_blank");
                            this.pollingLoad(row.serialNo)
                        } else {
                            const goodsParam = {
                                price: row.amount,
                                serialNo: row.serialNo,
                            };
                            this.$refs.payInfo.onShow(goodsParam, row.serialNo);
                        }
                    }
                });

            },
            onClickClose(row) {
                const that = this;
                this.$confirm("确认关闭该订单?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    that.onCloseOrder(row.serialNo);
                });
            },
            onCloseOrder(serialNo) {
                this.$axios({
                    url: this.$resource.tRechargeOrderCloseOrder,
                    method: "post",
                    data: {
                        serialNo,
                        oprUser: this.username,
                        orgCode: this.orgCode,
                    },
                }).then((res) => {
                    const bl = this.$utils.ajaxResponse.call(this, res);

                    if (bl) {
                        this.$message({
                            message: "关闭成功",
                            type: "success",
                        });
                        this.handleFilter();
                    } else {
                        this.$message.error(res.data.message);
                    }
                    // const bl = this.$utils.ajaxResponse.call(this, res)
                    // if (bl) {
                    //   this.$message({
                    //     message: '关闭成功',
                    //     type: 'success'
                    //   });
                    //   this.handleFilter()
                    // } else {
                    //   this.$message.error(res.data.msg);
                    // }
                });
            },
            filterOption(val, data) {
                if (!!val && !!data) {
                    return val.toLowerCase().indexOf(data.toLowerCase()) >= 0;
                }
                return false;
            },
            getList(param) {
                if (param) {
                    this.listQuery.pageNo = param.pageNo;
                    this.listQuery.pageSize = param.pageSize;
                }
                this.loading = true;
                this.listQuery["orgCode"] = this.orgCode;
                this.listQuery["oprUser"] = this.username;

                this.$axios({
                    url: this.$resource.tRechargeOrderPage
                        .replace("{pageNo}", this.listQuery.pageNo)
                        .replace("{pageSize}", this.listQuery.pageSize),
                    method: "post",
                    data: this.listQuery,
                })
                    .then((res) => {
                        const bl = this.$utils.ajaxResponse.call(this, res);
                        if (bl) {
                            this.loading = false;
                            this.tableData = res.data.data.list;
                            this.total = res.data.data.total;
                            // this.tableData = []
                            // const dd = res.data.data[0]
                            // for (let i = 0; i < 50; i++) {
                            //   this.tableData.push(dd)
                            // }
                            // this.list = this.tableData
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            },
        },
    };
</script>
<style lang="scss" scoped>
    .bg-box {
        // justify-content: center;
        // display: flex;
        width: 100%;
        background-image: url("../../assets/images/user-bg.png");
        background-size: contain;
        background-position: right bottom;
        background-repeat: no-repeat;
        background-attachment: initial;

        .box-card {
            box-shadow: 0px 2px 12px 0 rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            width: 86%;
            margin-top: 60px;
            margin-left: 7%;
            background-color: #ffffff;

            .content {
                padding: 20px;
            }

            a {
                color: #3D7FFF;
                cursor: pointer;
                text-decoration: underline;
                margin-right: 10px;
            }
        }

        .filter-container {
            margin: 10px 0px;

            .filter-item {
                // display: inline-block;
                // vertical-align: middle;
                margin-bottom: 10px;
                margin-right: 10px;
            }
        }
    }

    .tab-pagination /deep/ .el-pagination {
        margin: 20px;
    }

    .upload-opt-box {
        width: 100%;

        .upload-disabled /deep/ .el-upload>.el-upload-dragger {
            background-color: #e4e7ed;
            cursor: not-allowed;
        }

        .el-upload_png_text {
            color: #606266;
            font-size: 14px;
            text-align: center;
        }

        .img {
            z-index: 999;
            margin: 20px 0px;
            width: 200px;
            height: 200px;
        }

        .avatar-uploader {
            width: 100%;
        }

        .avatar-uploader /deep/ .el-upload {
            width: 100%;
        }

        .avatar-uploader /deep/ .el-upload>.el-upload-dragger {
            width: 100%;
        }

        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 120px;
            height: 120px;
            line-height: 120px;
            text-align: center;
            border: 1px dashed #dcdfe6;
        }

        .avatar {
            width: 145px;
            height: 145px;
            display: block;
        }
    }
</style>